import { Component } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { ExposedValidateXMLRes, XMLValidationError } from 'app/interfaces/responses/Exposed/exposedValidateXMLRes';
import { XMLValidationService } from 'app/services/api/xml-validation/xml-validation.service';
import { AlertsService } from 'app/services/system/alerts/alerts.service';

@Component({
    selector: 'xml-validation',
    templateUrl: './xml-validation.component.html',
})
export class XMLValidationComponent {
    xmlFile: File | null = null;
    schemaFile: File | null = null;
    result: ExposedValidateXMLRes | null = null;

    errorData: MatTableDataSource<XMLValidationError> = new MatTableDataSource();
    errorTableColumns: string[] = ['lineNumber', 'message'];

    constructor(
        private xmlValidationService: XMLValidationService,
        private alertsService: AlertsService
    ) {}

    onSelectXMLFile = (event: any): void => {
        if (event.addedFiles.length > 0) {
            var type = event.addedFiles[0].name.split('.').pop();
            if (type !== 'xml') {
                this.xmlFile = null;
                this.errorData.data = [];
                this.alertsService.changealertHeaderMessageFooter('Ekki rétt skráategund', 'Vinsamlegast veldu XML skjal', null);
            } else {
                this.xmlFile = event.addedFiles[0];
            }
        }
    };

    onRemoveXMLFile = (): void => {
        this.xmlFile = null;
    };

    onSelectSchemaFile = (event: any): void => {
        if (event.addedFiles.length > 0) {
            var type = event.addedFiles[0].name.split('.').pop();
            if (type !== 'xsd') {
                this.schemaFile = null;
                this.errorData.data = [];
                this.alertsService.changealertHeaderMessageFooter('Ekki rétt skráategund', 'Vinsamlegast veldu XSD skjal', null);
            } else {
                this.schemaFile = event.addedFiles[0];
            }
        }
    };

    onRemoveSchemaFile = (): void => {
        this.schemaFile = null;
    };

    validateXML = (): void => {
        if (this.xmlFile && this.schemaFile) {
            this.xmlValidationService.validateXML(this.xmlFile, this.schemaFile).subscribe({
                next: (res: ExposedValidateXMLRes) => {
                    this.result = res;
                    this.errorData.data = res.errors;
                },
                error: (_) => {
                    this.result = null;
                    this.errorData.data = [];
                },
            });
        }
    };
}
